import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ComponentsPeriodoDateInput } from "../Periodo/DateInput";
import { ComponentsModalidadeLookup } from "../Modalidade/Lookup";
import moment from "moment/min/moment-with-locales";
import { DataViewLayoutOptions } from "primereact/dataview";

export class ComponentsPedidoFiltroForm extends Component {

    constructor() {
        super();

        this.modalidadeComponente = React.createRef();

        this.state = {
            paciente: "",
            prontuario: "",
            acNumber: "",
            modalidades: [],
            dataInicial: "",
            dataFinal: "",
            dataAtual: "",
            sortKeyClear: false,
            ordenarSelected: ""
        };
    }

    static defaultProps = {
        onExecute: null
    }

    static propTypes = {
        onExecute: PropTypes.func
    }

    mobilecheck() {
        var check = false;
        (function (a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4)
                )
            )
                check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    componentDidMount() {
        this.filtroLimpar();
        document.addEventListener("keydown", this.handleKeyPress.bind(this));
    }

    filtroLimpar() {
        let ano = new Date().getFullYear();
        let mes = new Date().getMonth() + 1;
        let dia = new Date().getDate();
        const dataAtual = this._encodeDate(ano, mes, dia);
        this.setState({
            dataInicial: dataAtual,
            dataFinal: dataAtual,
            paciente: '',
            modalidades: [],
            prontuario: '',
            acNumber: ''
        });
        this.modalidadeComponente.current.limparModalidade();

        document.getElementById("dataInicial").focus();
        document.getElementById("dataFinal").focus();
        document.getElementById("dataFinal").blur();

        setTimeout(() => { this.handleBuscarClick(); }, 500);
    }

    handleClearDate() {
        if (this.state.prontuario || this.state.acNumber) {
            this.setState({
                dataInicial: null,
                dataFinal: null
            });
        }
    }

    handleBuscarClick() {
        this.handleClearDate();

        if (this.props.onExecute == null) {
            return;
        }

        setTimeout(() => {
            this.props.onExecute(this.state);
        }, 50);
    }

    handleLimparClick() {
        this.filtroLimpar();
        this.props.onSortChange("clear");
    }

    handleKeyPress = (event) => {
        this.handleClearDate();
        if (event.key == 'Enter') {

            if (event.target.tagName === "INPUT") {
                if (this.props.onExecute == null) {
                    return;
                }
                this.props.onExecute(this.state);
            }
        }
    }

    handleModalidade(event) {
        this.setState({ modalidades: event });
    }

    handleDataInicial(event) {
        let data = this._encodeDate(event.ano, event.mes, event.dia);
        this.setState({ dataInicial: data });
    }

    handleDataFinal(event) {
        let data = this._encodeDate(event.ano, event.mes, event.dia);
        this.setState({ dataFinal: data });
    }

    _encodeDate(ano, mes, dia) {
        try {
            return moment(ano + '-' + mes + '-' + dia, "YYYY-MM-DD").toDate();
        } catch (error) {
            return null;
        }
    }


    render() {

        const sortOptions = [
            { label: "Mais Novos", value: "DataEstudo Desc" },
            { label: "Mais Antigos", value: "DataEstudo Asc" },
            { label: "Procedimento", value: "Procedimento" }
        ];

        const dataViewLayoutOptions = <DataViewLayoutOptions layout={this.props.layout} onChange={e => this.props.onChangeDataViewLayoutOptions(e.value)} />

        let filtroForm = !this.props.mobilecheck() ? <div>

            <div className="p-grid">

                <div className="p-col-12 p-md-6 car-details">
                    <div className="p-col-12">
                        <label>Nome do Paciente:</label>
                    </div>
                    <div className="p-col-12">
                        <InputText
                            id="nomePaciente"
                            value={this.state.paciente}
                            onChange={(e) => { this.setState({ paciente: e.target.value }) }}
                            placeholder=""
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2">
                    <div className="p-col-12">
                        <label>Data Inicial:</label>
                    </div>
                    <div className="p-col-12">
                        <ComponentsPeriodoDateInput value={this.state.dataInicial} onChange={this.handleDataInicial.bind(this)} inputId="dataInicial" />
                    </div>
                </div>

                <div className="p-col-12 p-md-2" style={{ marginTop: "30px" }}>
                    <div className="p-col-12">
                        <Button
                            label="Buscar"
                            icon="pi pi-search"
                            onClick={() => this.setState({ sortKeyClear: false }), this.handleBuscarClick.bind(this)}
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2" style={{ marginTop: "30px" }}>
                    <div className="p-col-12">
                        {dataViewLayoutOptions}
                    </div>
                </div>

            </div>

            <div className="p-grid">
                <div className="p-col-12 p-md-2 car-details">
                    <div className="p-col-12">
                        <label>Prontuário:</label>
                    </div>
                    <div className="p-col-12">
                        <InputText
                            id="prontuario"
                            onChange={(e) => { this.setState({ prontuario: e.target.value }) }}
                            placeholder=""
                            value={this.state.prontuario}
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2 car-details">
                    <div className="p-col-12">
                        <label>Ac Number:</label>
                    </div>
                    <div className="p-col-12">
                        <InputText
                            id="acNumber"
                            onChange={(e) => { this.setState({ acNumber: e.target.value }) }}
                            placeholder=""
                            value={this.state.acNumber}
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2">
                    <div className="p-col-12">
                        <label>Modalidade:</label>
                    </div>
                    <div className="p-col-12">
                        <ComponentsModalidadeLookup
                            ref={this.modalidadeComponente}
                            value={this.state.modalidades}
                            onChange={this.handleModalidade.bind(this)}
                            required
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2">
                    <div className="p-col-12">
                        <label>Data Final:</label>
                    </div>
                    <div className="p-col-12">
                        <ComponentsPeriodoDateInput
                            value={this.state.dataFinal}
                            onChange={this.handleDataFinal.bind(this)}
                            inputId="dataFinal"
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2" style={{ marginTop: "30px" }}>
                    <div className="p-col-12">
                        <Button
                            label="Limpar"
                            icon="pi pi-replay"
                            onClick={this.handleLimparClick.bind(this)}
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2">
                    <div className="p-col-12">
                        <label>Ordenação:</label>
                    </div>
                    <div className="p-col-12"  >
                        <Dropdown
                            options={sortOptions}
                            value={this.props.sortKey}
                            placeholder="Ordenar por"
                            onChange={this.props.onSortChange}
                        />
                    </div>
                </div>

            </div>
        </div> : <div>

            <div className="p-grid">

                <div className="p-col-12 p-md-6 car-details">
                    <div className="p-col-12">
                        <label>Nome do Paciente:</label>
                    </div>
                    <div className="p-col-12">
                        <InputText
                            id="nomePaciente"
                            onChange={(e) => { this.setState({ paciente: e.target.value }) }}
                            placeholder=""
                            value={this.state.paciente}
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2">
                    <div className="p-col-12">
                        <label>Modalidade:</label>
                    </div>
                    <div className="p-col-12">
                        <ComponentsModalidadeLookup
                            ref={this.modalidadeComponente}
                            value={this.state.modalidades}
                            onChange={this.handleModalidade.bind(this)}
                            required
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2">
                    <div className="p-col-12">
                        <label>Data Inicial:</label>
                    </div>
                    <div className="p-col-12">
                        <ComponentsPeriodoDateInput
                            value={this.state.dataInicial}
                            onChange={this.handleDataInicial.bind(this)}
                            inputId="dataInicial"
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2">
                    <div className="p-col-12">
                        <label>Data Final:</label>
                    </div>
                    <div className="p-col-12">
                        <ComponentsPeriodoDateInput
                            value={this.state.dataFinal}
                            onChange={this.handleDataFinal.bind(this)}
                            inputId="dataFinal"
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-4">
                    <div className="p-col-12">
                        <label>Ordenação:</label>
                    </div>
                    <div className="p-col-12"  >
                        <Dropdown
                            options={sortOptions}
                            value={this.props.sortKey}
                            placeholder="Ordenar por"
                            onChange={this.props.onSortChange}
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2">
                    <div className="p-col-12">
                        <Button
                            label="Buscar"
                            icon="pi pi-search"
                            onClick={this.handleBuscarClick.bind(this)}
                        />
                    </div>
                </div>

                <div className="p-col-12 p-md-2">
                    <div className="p-col-12">
                        <Button
                            label="Limpar"
                            icon="pi pi-replay"
                            onClick={this.handleLimparClick.bind(this)}
                        />
                    </div>
                </div>

            </div>

        </div>;

        return (

            <div>

                {filtroForm}

            </div>

        );

    }
}